"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _textandgraphic_styles = _interopRequireDefault(require("./textandgraphic_styles"));

var _textandgraphic_definition = _interopRequireDefault(require("./textandgraphic_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : TEXT AND GRAPHIC LAYOUT ~~~~~~~~~~ ========== */


var TextAndGraphicLayout = (0, _reactJss.default)(_textandgraphic_styles.default)(function (props) {
  return _react.default.createElement("div", {
    className: "layout textandgraphiclayout ".concat(props.classes.textandgraphiclayout)
  }, _react.default.createElement(_index.Group, {
    name: "message"
  }, _react.default.createElement("div", {
    className: "headline"
  }, _react.default.createElement("h1", null, props.headline)), _react.default.createElement(_index.Title, null, _react.default.createElement("h2", null, props.title)), _react.default.createElement(_index.BodyCopy, null, props.bodycopy), props.additionalMessageContent), _react.default.createElement(_index.Group, {
    name: "visual"
  }, _react.default.createElement(_index.Illustration, {
    name: props.illustration,
    text: 'Visual Graphic'
  }), props.additionalVisualContent));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(TextAndGraphicLayout, _textandgraphic_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = TextAndGraphicLayout;
exports.default = _default;